/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface MonitoringFactBalanceRetrieve$Params {
  scenario_id: number;
}

export function monitoringFactBalanceRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringFactBalanceRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, monitoringFactBalanceRetrieve.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

monitoringFactBalanceRetrieve.PATH = '/api/monitoring/fact/balance/{scenario_id}/';
